import { render, staticRenderFns } from "./StatusDeposit.vue?vue&type=template&id=92df1470&scoped=true&"
import script from "./StatusDeposit.vue?vue&type=script&lang=ts&"
export * from "./StatusDeposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92df1470",
  null
  
)

export default component.exports